// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border[data-v-2cb04347] {\n    margin: 0;\n    box-shadow: none;\n    border: solid 1px var(--color-slate-two);\n}\n", ""]);
// Exports
module.exports = exports;
